export var Routes;

(function (Routes) {
  Routes["All"] = "*";
  Routes["Main"] = "/";
  Routes["Login"] = "/login";
  Routes["PasswordRecovery"] = "/password-recovery";
  Routes["ChangePassword"] = "/password-change";
  Routes["Registration"] = "/registration";
  Routes["Info"] = "/info";
  Routes["ConfirmEmail"] = "/client/confirm-email";
  Routes["Users"] = "/users";
  Routes["Error"] = "/error";
  Routes["NotFound"] = "/404";
})(Routes || (Routes = {}));